if (!customElements.get("back-in-stock")) {
  customElements.define(
    "back-in-stock",
    class BackInStock extends ModalDialog {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.klaviyoKey = this.dataset.klaviyoKey;
        this.variantSize = this.querySelector("[data-variant-size]");
        this.variantPrice = this.querySelector("[data-variant-price]");

        this.successNotice = this.querySelector(".success-notice");
        this.errorNotice = this.querySelector(".error-notice");

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.updateModal(event);
        });

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
      }

      hide() {
        super.hide();
      }

      showMessage(type) {
        if (type === "success") {
          this.successNotice.dataset.state = "visible";
        } else {
          this.errorNotice.dataset.state = "visible";
        }

        this.triggerHideMessageTimeout();
      }

      triggerHideMessageTimeout() {
        setTimeout(() => {
          this.successNotice.dataset.state = "hidden";
          this.errorNotice.dataset.state = "hidden";
        }, 5000);
      }

      updateModal(event) {
        // this.variantPrice.innerHTML = event.data.variant.price;
        this.variantId = event.data.variant.id.toString();
        this.variantSize.innerHTML = event.data.variant.option1;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const formData = new FormData(this.form);

        const options = {
          method: "POST",
          headers: {
            accept: "application/json",
            revision: "2023-10-15",
            "content-type": "application/json",
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: formData.get("email"),
                    },
                  },
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${this.variantId}`,
                  },
                },
              },
            },
          }),
        };

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.klaviyoKey}`, options)
          .then((response) => {
            console.log(response);
            if (response.status === 202) {
              console.log("Request accepted, but no content to parse as JSON");
              this.showMessage("success");
              return;
            } else {
              this.showMessage("error");
            }
          })
          .then((response) => {})
          .catch((err) => console.error(err));
      }
    },
  );
}
